export default __webpack_public_path__ + "static/media/bladder.f91366f5.jpg";